<ng-container *ngIf="!status && !smallLoader">
  <div *ngIf="messageSuccess; else other" [ngClass]="vh" class="center flex-column">
    <div class="spinner-border" [class]="spinnerColor" role="status"></div>
    {{ "spinner.loading" | translate }} {{ type ? type : "información" }}...
    <small class="text-muted" *ngIf="showSmall">{{ "spinner.searching-info" | translate }}</small>
  </div>
</ng-container>

<ng-template #other>
  <div [ngClass]="vh" class="center flex-column">
    <i class="fa fa-exclamation-triangle text-warning fa-2x" aria-hidden="true"></i>
    {{ "spinner.error-in" | translate }} {{ type }}...
    <small class="text-muted" *ngIf="showSmall">{{ "spinner.problem" | translate }}.</small>
  </div>
</ng-template>

<div *ngIf="status" [ngClass]="vh" class="center flex-column">
  <i class="fa fa-exclamation-triangle text-danger fa-2x" aria-hidden="true"></i>
  {{ errorText.name }}
  <small *ngIf="status && showSmall">{{ errorText.message }}</small>
</div>

<div
  *ngIf="smallLoader"
  class="spinner-border form-spinner"
  role="status"
  [class]="spinnerColor"
></div>
